import * as React from 'react';

const RepresentativeGraphicSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 144 144" {...props}>
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <path
                        fill="#F8FAFF"
                        d="M83 82.333L71.999 86 61 82.333V75l10.999 1.834L83 75z"
                    />
                    <path
                        d="M91.204 91C104.297 98.53 123 96.647 123 115.472V123H22v-7.528C22 96.647 40.703 98.53 53.796 91"
                        fill="#F6682F"
                    />
                    <path
                        fill="#D2D6DF"
                        d="M79.9 101l-7.401-7.6-7.398 7.6L54 91.5l3.7-9.5L72.5 85.8l14.8-3.8L91 91.5z"
                    />
                    <path
                        d="M52 45.182C52 33.584 61.178 28 72.5 28S93 33.584 93 45.182L83.68 49 72.5 45.182l-11.182-3.819L52 45.182z"
                        fill="#F6682F"
                    />
                    <path
                        d="M93 44.79v11.37c-1.863 13.262-9.318 18.946-9.318 18.946C79.955 77 72.5 77 72.5 77s-7.455 0-11.18-1.894c0 0-7.455-5.684-9.32-18.947V44.79L61.32 41l11.18 3.79 11.182 3.79L93 44.79z"
                        fill="#F8FAFF"
                    />
                    <path
                        d="M51 64c-4.971 0-9-4.253-9-9.5s4.029-9.5 9-9.5M93 45c4.971 0 9 4.253 9 9.5S97.971 64 93 64"
                        fill="#D2D6DF"
                    />
                    <path
                        d="M22 123v-7.53C22 96.647 40.823 98.528 54 91M91 91c13.177 7.53 32 5.647 32 24.472V123M79.9 101l-7.401-7.6-7.398 7.6L54 91.5l3.7-9.5L72.5 85.8l14.8-3.8L91 91.5z"
                        stroke="#3A3A3A"
                        strokeWidth={3}
                    />
                    <path
                        d="M84 75v7M61 82v-7"
                        stroke="#363A43"
                        strokeWidth={3}
                    />
                    <path
                        d="M93 45v11.295c-1.863 13.177-9.318 18.823-9.318 18.823C79.955 77 72.5 77 72.5 77s-7.455 0-11.18-1.882c0 0-7.455-5.646-9.32-18.823V45"
                        stroke="#3A3A3A"
                        strokeWidth={3}
                    />
                    <path
                        d="M52 45c0-11.475 9.178-17 20.5-17S93 33.525 93 45"
                        stroke="#3A3A3A"
                        strokeWidth={2.734}
                    />
                    <path
                        d="M92.625 45c5.178 0 9.375 4.104 9.375 9.167 0 5.062-4.197 9.166-9.375 9.166l-.664.12S88.875 67 72 67"
                        stroke="#3A3A3A"
                        strokeWidth={3}
                    />
                    <path
                        d="M44 48c0-18.665 12.536-28 28.001-28C87.464 20 100 29.335 100 48M70 116h4M70 108h4"
                        stroke="#3A3A3A"
                        strokeWidth={3}
                    />
                    <path
                        d="M53 64h-1.832C46.103 64 42 59.747 42 54.5s4.103-9.5 9.168-9.5"
                        stroke="#3A3A3A"
                        strokeWidth={3}
                    />
                    <path
                        stroke="#363A43"
                        strokeWidth={3}
                        d="M52 44.5l9.318-3.5L72.5 44.5 83.68 48 93 44.5"
                    />
                </g>
            </g>
        </g>
    </svg>
);

RepresentativeGraphicSvg.displayName = 'RepresentativeGraphicSvg';
export default RepresentativeGraphicSvg;
